import { type AxiosError, AxiosHeaders } from 'axios'
import useSWRMutation, { type SWRMutationResponse } from 'swr/mutation'

import {
  ContactControllerApiFactory,
  type RXPrescriptionRequestV1,
} from '@redteclab/api/clients/bully'

import { useGlooApi } from '../../../../api'
import { useGlobalConfigContext } from '../../../../global-config'

const getUseApiSwrRxLandingPageContactControllerPrescriptionPostMutationKey =
  (): string =>
    'useApiSwrRxLandingPageContactControllerPrescriptionPostMutationKey'

export const useApiSwrRxLandingPageContactControllerPrescriptionPostMutation =
  (): SWRMutationResponse<
    unknown,
    AxiosError,
    string,
    RXPrescriptionRequestV1
  > => {
    const globalConfig = useGlobalConfigContext()
    const client = useGlooApi(ContactControllerApiFactory)

    return useSWRMutation(
      getUseApiSwrRxLandingPageContactControllerPrescriptionPostMutationKey(),
      async (
        _swrKey: string,
        data: { arg: RXPrescriptionRequestV1 },
      ): Promise<unknown> => {
        const response = await client.contactV1TenantLanguageRxPrescriptionPost(
          {
            language: globalConfig.language,
            RXPrescriptionRequestV1: data.arg,
            tenant: globalConfig.tenantAndEnv,
          },
        )

        /*
         * https://github.com/axios/axios/issues/5967
         */
        return response.headers instanceof AxiosHeaders
          ? response.headers.get('date')
          : ''
      },
    )
  }
